import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from '@reduxjs/toolkit';

export const FlagSlice = createSlice({
    name: "booleanValue",
    initialState: {
        value: false
    },
    reducers: {
        setFlagValue(state, action: PayloadAction<boolean>) {
            state.value = action.payload;
        }
    }
});

export const { setFlagValue } =FlagSlice.actions;
export default FlagSlice.reducer;